<template>
  <div
      class="step"
      :class="{active: !answer, completed: answer }"
  >
    <div class="step-counter" :class="{'tooltip-open': tooltipIsOpen}" @click="openTooltip">
      <div class="step-number" v-text="stepIndex + 1"/>
      <template v-if="answer && checkIfThemeIsActive(availableThemes.Kabel24)">
        <img v-if="tooltipIsOpen" class="icon" :class="[getActiveTheme, {open: tooltipIsOpen}]"
             :src="publicImage('themes/kabel24/chevron-down-white.svg')">
        <img v-else class="icon" :class="[getActiveTheme, {open: tooltipIsOpen}]"
             :src="publicImage('themes/kabel24/chevron-down-primary.svg')">
      </template>
        <img v-else-if="answer" class="icon" :class="{open: tooltipIsOpen}" :src="publicImage('themes/elektramat/arrow-blue-left.svg')">
    </div>

    <transition name="collapse-left">
      <div class="step-label" v-if="!answer">
        <span class="label" v-text="question.short_name"/>
      </div>
    </transition>

    <tooltip
        v-if="answer"
        ref="tooltip"
        :option="answer"
        :open="tooltipIsOpen"
        @close="onTooltipClose"
        @previousStep="goHere"
    ></tooltip>
  </div>
</template>

<script>
import Tooltip from './Tooltip';
import {mapGetters} from "vuex";

export default {
  name: 'Step',

  components: {
    Tooltip,
  },

  props: {
    step: {
      type: Object,
      required: true,
    },
    stepIndex: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      tooltipIsOpen: false,
    };
  },

  computed: {
    ...mapGetters({
      checkIfThemeIsActive: 'theme/checkIfThemeIsActive',
      getActiveTheme: 'theme/getActiveTheme',
      availableThemes: 'theme/getAvailableThemes'
    }),

    question() {
      return this.$store.getters['questions/getQuestionById'](this.step.questionId);
    },
    answer() {
      return this.$store.getters['questions/getAnswer'](this.step);
    },
  },

  methods: {
    goHere() {
      this.$store.dispatch('preference/goBackToStep', this.stepIndex);
      this.tooltipIsOpen = false;
    },
    onTooltipClose() {
      this.tooltipIsOpen = false;
    },
    openTooltip() {
      if (!this.answer) {
        return;
      }

      this.tooltipIsOpen = true;
    },
  },
};
</script>

<style scoped lang="scss">

.collapse-left-enter-active,
.collapse-left-leave-active {
  transition: all .3s .3s ease;
  overflow: hidden;
  max-width: 200px;
  white-space: nowrap;
}

.collapse-left-leave-active {
  transition: all .3s .1s ease;
}

.collapse-left-enter, .collapse-left-leave-to {
  max-width: 0;
}

.step {
  $border-width: 1px;
  display: flex;
  position: relative;
  align-items: center;
  font-size: 18px;
  font-weight: var(--configurator-font-weight-bold);
  margin-right: 55px;
  color: var(--configurator-primary);
  cursor: pointer;
  user-select: none;
  font-family: var(--configurator-font-heading);

  @media only screen and (max-width: 576px) {
    margin-right: 20px;
    font-size: 12px;
  }

  &.active {
    cursor: default;

    .step-counter {
      color: var(--configurator-step-counter-color);
      background-color: var(--configurator-step-counter-background-color);
    }

    .step-label {
      color: var(--configurator-primary);
      font-weight: var(--configurator-step-label-font-weight);
    }
  }

  &.completed {
    position: relative;

    @media only screen and (max-width: 576px) {
      display: flex;
      .icon {
        display: none;
      }
    }

    .step-counter:after {
      transform: scale(1);

      @media only screen and (max-width: 576px) {
        transition: all ease 0.3s 0.4s;
      }
    }
  }

  .step-number {
    display: flex;
    align-items: center;
    justify-content: center;
    height: calc(30px - $border-width * 2);
    font-weight: var(--configurator-font-weight-bold);
    transition: all ease .3s;
    font-family: var(--configurator-font-heading);
    padding-top: 2px;

    @media only screen and (max-width: 576px) {
      font-size: 14px;
    }
  }

  .step-counter {
    display: flex;
    position: relative;
    color: var(--configurator-primary);
    border-radius: var(--configurator-step-counter-border-radius);
    border: $border-width solid var(--configurator-primary);
    min-width: calc(30px - $border-width * 2);
    padding: 0 10px;
    justify-content: center;

    &.tooltip-open {
      border-radius: 12px 12px 0 0;
      background: var(--configurator-primary);
      color: white;
    }

    &:after {
      content: '';
      position: absolute;
      left: calc(100% + 15px);
      top: 50%;
      width: 20px;
      height: 1px;
      background-color: $gray-100;
      transform: scale(0);
      transition: all ease 0.3s 0.4s;

      @media only screen and (max-width: 576px) {
        content: '';
        position: absolute;
        right: -15px;
        top: 0;
        left: unset;
        bottom: 0;
        height: unset;
        width: 1px;
        background-color: $gray-100;
        transition: all ease 0.3s;
      }
    }
  }

  .step-label {
    color: var(--configurator-primary);
    margin-left: 10px;

    @media only screen and (max-width: 576px) {
      margin-left: 7px;
    }

    .label {
      position: relative;
    }
  }

  .icon {
    margin-left: 5px;
    width: 8px;
    transition: all ease 0.3s;
      transform: rotate(-90deg);

    &.kabel-24 {
      transform: rotate(0deg);

      &.open {
        transform: rotate(180deg);
      }
    }

    &.open {
      transform: rotate(90deg);
    }

    @media only screen and (max-width: 576px) {
      position: absolute;
      top: unset;
      bottom: -10px;
      left: calc(50% - 7px);
      margin-left: 0;
      margin-top: 2px;
      width: 14px;
      height: 8px;
    }
  }
}

.slide-enter-active,
.slide-leave-active {
  transition: all 0.5s ease;
}

.slide-enter,
.slide-leave-to {
  transform: translate(25%, 0);
  opacity: 0;
}
</style>
